// app/javascript/folio_card_modals.js
// Modern, CSP-compliant modal and kebab context menu orchestrator for Folio cards and folders

(function () {
  // 1. Generic Document/Folio Card Modal (Archive, Unarchive, Delete, Convert to Template)
  function openDocumentCardModal (modalId, formId, actionUrl, titleText) {
    const modal = document.getElementById(modalId)
    const form = document.getElementById(formId)

    if (titleText && modal) {
      const titleEl = modal.querySelector('h3')
      if (titleEl) titleEl.textContent = titleText
    }

    if (form) {
      if (actionUrl) form.action = actionUrl
      if (!form.dataset.boundSubmitClose) {
        form.dataset.boundSubmitClose = 'true'
        form.addEventListener('submit', () => {
          if (modal && typeof modal.close === 'function') {
            modal.close()
          }
        })
      }
    }

    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) {
        modal.showModal()
      }
    }
  }

  // 2. Rename Modal (Folios & Folders)
  function openRenameModal (name, actionUrl, inputName = 'template[name]') {
    const modal = document.getElementById('global_rename_modal')
    const form = document.getElementById('global_rename_form')
    const input = document.getElementById('global_rename_input')

    if (form) {
      if (actionUrl) form.action = actionUrl
      if (!form.dataset.boundSubmitClose) {
        form.dataset.boundSubmitClose = 'true'
        form.addEventListener('submit', () => {
          if (modal && typeof modal.close === 'function') {
            modal.close()
          }
        })
      }
    }

    if (input) {
      input.name = inputName
      input.value = name || ''
    }

    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) {
        modal.showModal()
      }
      setTimeout(() => input?.focus(), 50)
    }
  }

  // 3. Move Folder Modal
  function openMoveFolderModal (templateId, templateName, currentFolderId, actionUrl) {
    const modal = document.getElementById('global_move_folder_modal')
    const form = document.getElementById('global_move_folder_form')
    const select = document.getElementById('global_move_folder_select')
    const titleEl = document.getElementById('global_move_folder_item_title')
    const newNameWrapper = document.getElementById('global_move_folder_new_name_wrapper')
    const newNameInput = document.getElementById('global_move_folder_new_name_input')

    if (form) {
      if (actionUrl) form.action = actionUrl
      if (!form.dataset.boundSubmitClose) {
        form.dataset.boundSubmitClose = 'true'
        form.addEventListener('submit', () => {
          if (modal && typeof modal.close === 'function') {
            modal.close()
          }
        })
      }
    }

    if (titleEl) {
      titleEl.textContent = `Moving: ${templateName || 'Folio'}`
    }

    if (select) {
      select.value = currentFolderId || ''
    }

    if (newNameWrapper) {
      newNameWrapper.classList.add('hidden')
    }
    if (newNameInput) {
      newNameInput.value = ''
    }

    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) {
        modal.showModal()
      }
    }
  }

  // 4. Handle Move Folder Select Dropdown Change
  function handleMoveFolderSelectChange (selectEl) {
    if (!selectEl) return
    const newNameWrapper = document.getElementById('global_move_folder_new_name_wrapper')
    const newNameInput = document.getElementById('global_move_folder_new_name_input')
    if (!newNameWrapper) return

    if (selectEl.value === '__new__') {
      newNameWrapper.classList.remove('hidden')
      newNameInput?.focus()
    } else {
      newNameWrapper.classList.add('hidden')
      if (newNameInput) newNameInput.value = ''
    }
  }

  // 5. Clone / Copy Folio Modal
  function openCloneFolioModal (templateId, templateName, currentFolderId, actionUrl, isReusable) {
    const modal = document.getElementById('global_clone_modal')
    const form = document.getElementById('global_clone_form')
    const nameInput = document.getElementById('global_clone_name_input')
    const folderSelect = document.getElementById('global_clone_folder_select')
    const titleEl = document.getElementById('global_clone_title')
    const subtitleEl = document.getElementById('global_clone_subtitle')
    const submitBtnText = document.getElementById('global_clone_submit_btn_text')

    if (form) {
      if (actionUrl) form.action = actionUrl
      if (!form.dataset.boundSubmitClose) {
        form.dataset.boundSubmitClose = 'true'
        form.addEventListener('submit', () => {
          if (modal && typeof modal.close === 'function') {
            modal.close()
          }
        })
      }
    }

    const reusable = isReusable === true || isReusable === 'true'
    if (titleEl) {
      titleEl.textContent = reusable ? 'Clone Template' : 'Copy Folio'
    }
    if (subtitleEl) {
      subtitleEl.textContent = reusable
        ? 'Create a reusable duplicate of this template with all field placements preserved.'
        : 'Create a copy of this folio with all field placements preserved.'
    }
    if (submitBtnText) {
      submitBtnText.textContent = reusable ? 'Clone Template' : 'Copy Folio'
    }

    if (nameInput) {
      const cleanName = (templateName || '').replace(/\s*\((?:Copy|Clone)(?:\s+\d+)?\)$/, '')
      nameInput.value = `${cleanName} (Copy)`
    }

    if (folderSelect) {
      folderSelect.value = currentFolderId || ''
    }

    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) {
        modal.showModal()
      }
      setTimeout(() => nameInput?.focus(), 50)
    }
  }

  // 6. Delete Folder Modal
  function openDeleteFolderModal (name, actionUrl, totalItems, foliosCount, subfoldersCount) {
    const modal = document.getElementById('global_delete_folder_modal')
    const form = document.getElementById('global_delete_folder_form')
    const title = document.getElementById('global_delete_folder_title')
    const subtitle = document.getElementById('global_delete_folder_subtitle')
    const options = document.getElementById('global_delete_folder_options')
    const emptyMsg = document.getElementById('global_delete_folder_empty_msg')
    const reassignText = document.getElementById('global_delete_folder_reassign_text')

    if (form && actionUrl) form.action = actionUrl
    if (title) title.textContent = `Delete Folder "${name}"`
    const total = parseInt(totalItems || '0', 10)
    if (subtitle) {
      subtitle.textContent = (total > 0)
        ? `Contains ${foliosCount || 0} folio(s) and ${subfoldersCount || 0} subfolder(s)`
        : 'Empty folder'
    }
    if (options && emptyMsg) {
      if (total > 0) {
        options.classList.remove('hidden')
        emptyMsg.classList.add('hidden')
        if (reassignText) reassignText.textContent = `Keep all ${foliosCount || 0} folio(s) and signed agreements intact; only remove the folder container.`
      } else {
        options.classList.add('hidden')
        emptyMsg.classList.remove('hidden')
      }
    }
    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal()
    }
  }

  // 7. Archive Folder Modal
  function openArchiveFolderModal (name, actionUrl) {
    const modal = document.getElementById('global_archive_folder_modal')
    const form = document.getElementById('global_archive_folder_form')
    const desc = document.getElementById('global_archive_folder_desc')
    if (form && actionUrl) form.action = actionUrl
    if (desc) desc.textContent = `The folder "${name}" and its contents will be moved to your Archive.`
    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal()
    }
  }

  // 8. Unarchive Folder Modal
  function openUnarchiveFolderModal (name, actionUrl) {
    const modal = document.getElementById('global_unarchive_folder_modal')
    const form = document.getElementById('global_unarchive_folder_form')
    const desc = document.getElementById('global_unarchive_folder_desc')
    if (form && actionUrl) form.action = actionUrl
    if (desc) desc.textContent = `The folder "${name}" will be restored to your active folios list.`
    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal()
    }
  }

  // 9. Bulk Actions Controller
  const DoccuFoliosBulk = {
    selectedIds: [],
    toggleSelect: function (id, event) {
      if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation()
      }
      id = parseInt(id, 10)
      if (isNaN(id)) return
      const index = this.selectedIds.indexOf(id)
      if (index > -1) {
        this.selectedIds.splice(index, 1)
      } else {
        if (this.selectedIds.length >= 100) {
          alert('You can select a maximum of 100 items at a time.')
          this.syncUI()
          return
        }
        this.selectedIds.push(id)
      }
      this.syncUI()
    },
    selectAllVisible: function () {
      const checkboxes = document.querySelectorAll('.folio-card-checkbox')
      const ids = Array.from(checkboxes).map(cb => parseInt(cb.value, 10)).filter(id => !isNaN(id))
      this.selectedIds = Array.from(new Set([...this.selectedIds, ...ids]))
      this.syncUI()
    },
    clearSelection: function () {
      this.selectedIds = []
      this.syncUI()
    },
    syncUI: function () {
      const bar = document.getElementById('folios_bulk_bar')
      const countEl = document.getElementById('folios_bulk_count')
      const btnText = document.getElementById('folios_bulk_btn_text')
      const modalText = document.getElementById('global_bulk_delete_text')

      const checkboxes = document.querySelectorAll('.folio-card-checkbox')
      checkboxes.forEach(cb => {
        const id = parseInt(cb.value, 10)
        cb.checked = this.selectedIds.includes(id)
        const card = cb.closest('.group')
        const wrapper = cb.closest('.folio-checkbox-wrapper')
        if (card) {
          if (this.selectedIds.includes(id)) {
            card.classList.add('ring-2', 'ring-[#01d680]', 'border-[#01d680]')
            if (wrapper) wrapper.classList.add('opacity-100')
          } else {
            card.classList.remove('ring-2', 'ring-[#01d680]', 'border-[#01d680]')
            if (wrapper) wrapper.classList.remove('opacity-100')
          }
        }
      })

      if (this.selectedIds.length > 0) {
        if (bar) bar.classList.remove('hidden')
        if (countEl) countEl.innerText = `${this.selectedIds.length} selected`
        if (btnText) btnText.innerText = `Delete selected (${this.selectedIds.length})`
        if (modalText) modalText.innerText = `Are you sure you want to permanently delete these ${this.selectedIds.length} selected items? All associated files will be removed, and an immutable cryptographic audit record will be logged for compliance.`
      } else {
        if (bar) bar.classList.add('hidden')
      }
    },
    submitBulkDelete: async function () {
      if (this.selectedIds.length === 0) return
      const btn = document.getElementById('global_bulk_delete_confirm_btn')
      const cancelBtn = document.getElementById('global_bulk_delete_cancel_btn')
      const backdropBtn = document.getElementById('global_bulk_delete_backdrop_btn')
      const errEl = document.getElementById('global_bulk_delete_error')
      const textEl = document.getElementById('global_bulk_delete_text')
      const progressContainer = document.getElementById('global_bulk_delete_progress_container')
      const progressBar = document.getElementById('global_bulk_delete_progress_bar')
      const percentageEl = document.getElementById('global_bulk_delete_percentage')
      const statusMsg = document.getElementById('global_bulk_delete_status_msg')
      const spinner = document.getElementById('global_bulk_delete_spinner')
      const titleEl = document.getElementById('global_bulk_delete_title')

      if (btn) btn.disabled = true
      if (cancelBtn) cancelBtn.disabled = true
      if (backdropBtn) backdropBtn.disabled = true
      if (errEl) { errEl.classList.add('hidden'); errEl.innerText = '' }
      if (textEl) textEl.classList.add('hidden')
      if (progressContainer) progressContainer.classList.remove('hidden')

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      const total = this.selectedIds.length

      try {
        if (progressBar) progressBar.style.width = '40%'
        if (percentageEl) percentageEl.innerText = '40%'
        if (statusMsg) statusMsg.innerText = `Deleting ${total} item(s)...`

        const response = await fetch('/folios/bulk_destroy.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({ ids: this.selectedIds })
        })

        const data = await response.json().catch(() => ({}))
        if (!response.ok || data.success === false) {
          throw new Error(data.error || 'Failed to delete selected items.')
        }

        if (progressBar) {
          progressBar.style.width = '100%'
          progressBar.classList.remove('bg-[#dc2626]')
          progressBar.classList.add('bg-[#01d680]')
        }
        if (percentageEl) percentageEl.innerText = '100%'
        if (spinner) spinner.classList.add('hidden')
        if (statusMsg) {
          const count = data.deleted_count || total
          statusMsg.innerText = `Successfully deleted ${count} item(s).`
          statusMsg.classList.remove('text-[#5b5c60]')
          statusMsg.classList.add('text-[#00721b]', 'font-bold')
        }
        if (titleEl) titleEl.innerText = 'Deletion Complete'

        setTimeout(() => {
          window.location.reload()
        }, 800)
      } catch (err) {
        if (errEl) {
          errEl.innerText = err.message || 'A network error occurred. Please try again.'
          errEl.classList.remove('hidden')
        }
        if (btn) btn.disabled = false
        if (cancelBtn) cancelBtn.disabled = false
        if (backdropBtn) backdropBtn.disabled = false
        if (spinner) spinner.classList.remove('hidden')
      }
    }
  }

  // 10. Kebab Menu Toggle & Dismissal
  function toggleKebabMenu (triggerEl) {
    const container = triggerEl.closest('[data-folio-kebab]') || triggerEl.parentElement
    const menu = container ? container.querySelector('[data-folio-kebab-menu]') : null
    if (!menu) return

    const wasOpen = menu.classList.contains('is-open')
    closeAllKebabMenus()
    if (!wasOpen) {
      menu.classList.add('is-open')
      triggerEl.setAttribute('aria-expanded', 'true')
    }
  }

  function closeAllKebabMenus () {
    document.querySelectorAll('[data-folio-kebab-menu].is-open').forEach((menu) => {
      menu.classList.remove('is-open')
      const trigger = menu.closest('[data-folio-kebab]')?.querySelector('[data-folio-kebab-trigger]')
      if (trigger) trigger.setAttribute('aria-expanded', 'false')
    })
  }

  // 11. Dispatch Folio Card Action
  function handleFolioCardAction (actionEl) {
    const action = actionEl.getAttribute('data-folio-action')
    if (!action) return

    switch (action) {
      case 'copy': {
        const templateId = actionEl.getAttribute('data-template-id')
        const templateName = actionEl.getAttribute('data-template-name')
        const folderId = actionEl.getAttribute('data-folder-id')
        const actionUrl = actionEl.getAttribute('data-action-url') || actionEl.getAttribute('data-clone-url')
        const isReusable = actionEl.getAttribute('data-is-reusable') === 'true'
        openCloneFolioModal(templateId, templateName, folderId, actionUrl, isReusable)
        break
      }
      case 'rename': {
        const name = actionEl.getAttribute('data-template-name')
        const actionUrl = actionEl.getAttribute('data-action-url')
        const inputName = actionEl.getAttribute('data-input-name') || 'template[name]'
        openRenameModal(name, actionUrl, inputName)
        break
      }
      case 'move-folder': {
        const templateId = actionEl.getAttribute('data-template-id')
        const templateName = actionEl.getAttribute('data-template-name')
        const folderId = actionEl.getAttribute('data-folder-id')
        const actionUrl = actionEl.getAttribute('data-action-url')
        openMoveFolderModal(templateId, templateName, folderId, actionUrl)
        break
      }
      case 'archive': {
        const modalId = actionEl.getAttribute('data-modal-id') || 'global_archive_modal'
        const formId = actionEl.getAttribute('data-form-id') || 'global_archive_form'
        const actionUrl = actionEl.getAttribute('data-action-url')
        const titleText = actionEl.getAttribute('data-title-text')
        openDocumentCardModal(modalId, formId, actionUrl, titleText)
        break
      }
      case 'unarchive': {
        const modalId = actionEl.getAttribute('data-modal-id') || 'global_unarchive_modal'
        const formId = actionEl.getAttribute('data-form-id') || 'global_unarchive_form'
        const actionUrl = actionEl.getAttribute('data-action-url')
        const titleText = actionEl.getAttribute('data-title-text')
        openDocumentCardModal(modalId, formId, actionUrl, titleText)
        break
      }
      case 'delete': {
        const modalId = actionEl.getAttribute('data-modal-id') || 'global_delete_modal'
        const formId = actionEl.getAttribute('data-form-id') || 'global_delete_form'
        const actionUrl = actionEl.getAttribute('data-action-url')
        const titleText = actionEl.getAttribute('data-title-text')
        openDocumentCardModal(modalId, formId, actionUrl, titleText)
        break
      }
      case 'convert-template': {
        const modalId = actionEl.getAttribute('data-modal-id') || 'global_convert_modal'
        const formId = actionEl.getAttribute('data-form-id') || 'global_convert_form'
        const actionUrl = actionEl.getAttribute('data-action-url')
        const titleText = actionEl.getAttribute('data-title-text')
        openDocumentCardModal(modalId, formId, actionUrl, titleText)
        break
      }
      case 'share': {
        const assetType = actionEl.getAttribute('data-asset-type') || 'Template'
        const assetId = actionEl.getAttribute('data-asset-id')
        const assetName = actionEl.getAttribute('data-asset-name')
        if (typeof window.openShareModal === 'function') {
          window.openShareModal({ assetType, assetId, assetName })
        }
        break
      }
      case 'delete-folder': {
        const name = actionEl.getAttribute('data-folder-name')
        const actionUrl = actionEl.getAttribute('data-action-url')
        const totalItems = actionEl.getAttribute('data-total-items')
        const foliosCount = actionEl.getAttribute('data-folios-count')
        const subfoldersCount = actionEl.getAttribute('data-subfolders-count')
        openDeleteFolderModal(name, actionUrl, totalItems, foliosCount, subfoldersCount)
        break
      }
      case 'archive-folder': {
        const name = actionEl.getAttribute('data-folder-name')
        const actionUrl = actionEl.getAttribute('data-action-url')
        openArchiveFolderModal(name, actionUrl)
        break
      }
      case 'unarchive-folder': {
        const name = actionEl.getAttribute('data-folder-name')
        const actionUrl = actionEl.getAttribute('data-action-url')
        openUnarchiveFolderModal(name, actionUrl)
        break
      }
    }
  }

  // Expose global API on window
  window.openDocumentCardModal = openDocumentCardModal
  window.openRenameModal = openRenameModal
  window.openMoveFolderModal = openMoveFolderModal
  window.handleMoveFolderSelectChange = handleMoveFolderSelectChange
  window.openCloneFolioModal = openCloneFolioModal
  window.openDeleteFolderModal = openDeleteFolderModal
  window.openArchiveFolderModal = openArchiveFolderModal
  window.openUnarchiveFolderModal = openUnarchiveFolderModal
  window.DoccuFoliosBulk = DoccuFoliosBulk

  // 12. Top-level Delegated Listeners (CSP & Turbo resilient)
  document.addEventListener('click', function (e) {
    // A. Folio Card Context Action
    const actionEl = e.target.closest('[data-folio-action]')
    if (actionEl) {
      e.preventDefault()
      e.stopPropagation()
      handleFolioCardAction(actionEl)
      closeAllKebabMenus()
      return
    }

    // B. Kebab Trigger
    const triggerEl = e.target.closest('[data-folio-kebab-trigger]')
    if (triggerEl) {
      e.preventDefault()
      e.stopPropagation()
      toggleKebabMenu(triggerEl)
      return
    }

    // C. Modal Close Trigger
    const closeModalBtn = e.target.closest('[data-action="close-modal"]')
    if (closeModalBtn) {
      const targetId = closeModalBtn.getAttribute('data-target')
      if (targetId) {
        e.preventDefault()
        e.stopPropagation()
        const m = document.getElementById(targetId)
        if (m && typeof m.close === 'function') m.close()
      }
      return
    }

    // D. Bulk Select All
    if (e.target.closest('[data-action="bulk-select-all"]')) {
      e.preventDefault()
      e.stopPropagation()
      DoccuFoliosBulk.selectAllVisible()
      return
    }

    // E. Bulk Clear
    if (e.target.closest('[data-action="bulk-clear"]')) {
      e.preventDefault()
      e.stopPropagation()
      DoccuFoliosBulk.clearSelection()
      return
    }

    // F. Bulk Delete Modal Confirm
    if (e.target.closest('[data-action="bulk-delete-confirm"]')) {
      e.preventDefault()
      e.stopPropagation()
      DoccuFoliosBulk.submitBulkDelete()
      return
    }

    // G. Bulk Delete Open Modal
    if (e.target.closest('[data-action="bulk-open-delete-modal"]')) {
      e.preventDefault()
      e.stopPropagation()
      const m = document.getElementById('global_bulk_delete_modal')
      if (m && typeof m.showModal === 'function') m.showModal()
      return
    }

    // H. Outside click dismisses kebab menus
    if (!e.target.closest('[data-folio-kebab]')) {
      closeAllKebabMenus()
    }
  })

  // Delegated Change Listener
  document.addEventListener('change', function (e) {
    // 1. Move Folder Select
    const sel = e.target.closest('[data-action="move-folder-select"], #global_move_folder_select')
    if (sel) {
      handleMoveFolderSelectChange(sel)
      return
    }

    // 2. Folio Card Selection Checkbox
    const cb = e.target.closest('.folio-card-checkbox, [data-action="toggle-folio-select"]')
    if (cb) {
      DoccuFoliosBulk.toggleSelect(cb.value, e)
    }
  })

  // Keyboard Escape Dismissal
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllKebabMenus()
    }
  })

  // Turbo Navigation Resets
  const resetUI = () => {
    closeAllKebabMenus()
    DoccuFoliosBulk.syncUI()
  }

  document.addEventListener('turbo:load', resetUI)
  document.addEventListener('turbo:render', resetUI)
  document.addEventListener('turbo:frame-load', resetUI)
})()
